{
  "name": "dkg-solitaire",
  "version": "0.1.37",
  "private": true,
  "type": "module",
  "description": "Le Solitaire - Klondike 3D, seul a une table de taverne medievale.",
  "scripts": {
    "dev": "vite",
    "build": "tsc --noEmit && vite build",
    "preview": "vite preview",
    "test": "vitest run",
    "test:watch": "vitest",
    "deploy": "npm run build && node scripts/deploy-ftp.mjs"
  },
  "dependencies": {
    "@fontsource/cinzel": "^5.3.0",
    "@fontsource/im-fell-english": "^5.3.0",
    "@fontsource/metamorphous": "^5.3.0",
    "three": "^0.185.1"
  },
  "devDependencies": {
    "@types/three": "^0.185.4",
    "basic-ftp": "^6.2.0",
    "dotenv": "^17.4.2",
    "typescript": "~7.0.2",
    "vite": "^8.2.1",
    "vitest": "^4.1.10"
  }
}
